/**
 * Storefront ACL – Category Mappers.
 *
 * Transforma PublicCategoryTreeNode del backend al CategoryNode
 * que consumen Navbar, CategoryBar y CatalogPage.
 *
 * Diferencia con el mapper legacy: este preserva `id` del backend,
 * que es necesario para filtros por categoryId si se requiere.
 */

import type { PublicCategoryTreeNode } from "./types";

// ─────────────────────────────────────────────────────────────────────────────
// CategoryNode legacy – shape que consumen los componentes React
// ─────────────────────────────────────────────────────────────────────────────

export type SubCat = {
  id: string;
  slug: string;
  name: string;
  imageUrl: string | null;
};

export type CategoryNode = {
  id: string;
  slug: string;
  name: string;
  imageUrl: string | null;
  sub?: SubCat[];
};

// ─────────────────────────────────────────────────────────────────────────────
// Mapper
// ─────────────────────────────────────────────────────────────────────────────

/** Mapea un nodo del árbol de categorías público al shape legacy CategoryNode. */
export function mapTreeNodeToCategory(
  node: PublicCategoryTreeNode,
): CategoryNode {
  return {
    id: node.id,
    slug: node.slug,
    name: node.name,
    imageUrl: null, // El backend no envía imageUrl en el tree todavía
    sub: (node.children ?? []).map((child) => ({
      id: child.id,
      slug: child.slug,
      name: child.name,
      imageUrl: null,
    })),
  };
}

/**
 * Nodo virtual "Todos" que se prepend al array de categorías.
 * Equivale a "sin filtro de categoría".
 */
export const ALL_CATEGORIES_NODE: CategoryNode = {
  id: "",
  slug: "all",
  name: "Todos",
  imageUrl: null,
  sub: [],
};
